import globalService from './api/global.service'

export async function checkSubDomainIsAvailable(subdomain: string) {
    if (!subdomain) return
    const res = await globalService.checkSubdomain(subdomain)
    return res.data
}

export default checkSubDomainIsAvailable
